<template>
    <section id="restaurante" class="section py-20 bg-neutral-700">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex flex-col lg:flex-row items-center">
                <div class="lg:w-1/2 mb-10 lg:mb-0 lg:pr-10">
                    <h2 class="text-3xl md:text-4xl font-bold text-white mb-6">Sabores Inesquecíveis</h2>
                    <p class="text-lg text-white mb-6">Descubra uma experiência gastronômica refinada com pratos preparados por chefs premiados.</p>
                    <p class="text-lg text-white mb-8">Ingredientes frescos, técnicas sofisticadas e um ambiente acolhedor esperam por você.</p>
                    <div class="bg-white/20 backdrop-blur-sm p-6 rounded-lg">
                        <div class="flex items-center mb-4">
                            <i class="fas fa-utensils text-white text-xl mr-3"></i>
                            <span class="text-white font-semibold">Gastronomia de Excelência</span>
                        </div>
                        <p class="text-white">Saboreie pratos exclusivos em um restaurante que une sofisticação e autenticidade.</p>
                    </div>
                </div>

                <!-- Carrossel -->
                <div class="lg:w-1/2">
                    <Swiper :modules="[Grid, Autoplay]" :slides-per-view="2" :grid="{ rows: 2, fill: 'row' }" :space-between="24" :loop="images.length > 4" :autoplay="images.length > 4 ? { delay: 4000, disableOnInteraction: false } : false" class="w-full p-4 bg-transparent">
                        <SwiperSlide v-for="(image, index) in images" :key="index" class="overflow-visible">
                            <img :src="image.src" :alt="image.alt" class="w-full h-72 object-cover rounded-lg shadow-lg transition-transform duration-300 ease-in-out
                                hover:scale-110 hover:z-10 will-change-transform" style="transform-origin: center center;" />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>

            <div class="grid md:grid-cols-3 gap-8 mt-12">
                <div class="text-center">
                    <div class="bg-neutral-600 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-utensils text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Gastronomia Autoral</h3>
                    <p class="text-gray-200">Pratos exclusivos criados por chefs renomados, com sabores que surpreendem.</p>
                </div>
                <div class="text-center">
                    <div class="bg-neutral-600 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-leaf text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Ingredientes Frescos</h3>
                    <p class="text-gray-200">Utilizamos produtos orgânicos e locais para garantir qualidade e sabor autêntico.</p>
                </div>
                <div class="text-center">
                    <div class="bg-neutral-600 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-chair text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Ambiente Aconchegante</h3>
                    <p class="text-gray-200">Decoração charmosa, iluminação suave e vista privilegiada para uma refeição memorável.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Grid } from 'swiper/modules';

const images = [
    { src: 'https://images.unsplash.com/photo-1603105037880-880cd4edfb0d?auto=format&fit=crop&w=687&q=80', alt: 'Prato sofisticado' },
    { src: 'https://images.unsplash.com/photo-1611270629569-8b357cb88da9?auto=format&fit=crop&w=687&q=80', alt: 'Ambiente do restaurante' },
    { src: 'https://www.ricettealvolo.it/wp-content/uploads/2023/02/lasagne-bolognese.jpg', alt: 'Mesa posta' },
    { src: 'https://www.receitasagora.com.br/wp-content/uploads/2020/07/receita-de-panna-cotta.jpg', alt: 'Pratos variados' },
    { src: 'https://www.ricettealvolo.it/wp-content/uploads/2023/02/lasagne-bolognese.jpg', alt: 'Mesa posta' },
    { src: 'https://www.receitasagora.com.br/wp-content/uploads/2020/07/receita-de-panna-cotta.jpg', alt: 'Pratos variados' }
];
</script>
